export const getOfferExpirationDate = (expirationDate?: string | null) => {
  if (expirationDate) {
    return new Date(expirationDate);
  }

  const now = new Date();

  return new Date(now.getFullYear(), now.getMonth() + 1, 0);
};

export const formatOfferExpirationDate = (expirationDate?: string | null) => {
  return getOfferExpirationDate(expirationDate).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};
